module.exports = __webpack_public_path__ + "img/martin-alexis.e2a7649c.png";